import { FetchResult, gql } from 'apollo-boost';
import { ICharacter } from '../../../models/character';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query CharactersForNarrative($narrative_uid: String!){
        characters_for_narrative(narrative_uid: $narrative_uid) {
            uid,
            name,
            fileName: file_name,
            externalImageUrl: external_image_url,
        }
    }
`;

export async function getCharacters(narrativeUid: string): Promise<ICharacter[]> {
    const result: FetchResult<{ characters_for_narrative: ICharacter[] }> = await graphqlClient.query({
        query: QUERY,
        variables: { narrative_uid: narrativeUid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.characters_for_narrative;
}

